// extracted by mini-css-extract-plugin
export var content = "_qm-1";
export var fullScreen = "_qm-0";